import {
  INPUT_MANAGEMENT_METER_MONTH_MODEL_LIST,
  INPUT_MANAGEMENT_METER_MONTH_SEARCH,
  INPUT_MANAGEMENT_METER_MONTH_PAGINATION,
  INPUT_MANAGEMENT_METER_MONTH_DROP_DOWN_SEARCH_TYPE,
  INPUT_MANAGEMENT_METER_MONTH_DROP_DOWN_SEARCH_SOURCE,
} from "./actionType";

import moment from 'moment';

const initialState = {
  modelDeviceList: [],
  modelSearch: { UPLOAD_DATE: "", UPLOAD_TO_DATE: "", UPLOADTYPE_NAME: null, SOURCE_NAME: null, STATUS_FLAG: 0, LOAD_TYPE: 2, SEARCH_METER_MONTH: "" }, //UPLOAD_START: "", UPLOAD_TO: "",
  dropDownSearchType: null,
  dropDownSearchDataSource: null,
  pagination: { sizePerPage: 100, page: 1 }
};

export default (state = initialState, action) => {
  // console.log(action);
  switch (action.type) {
    case INPUT_MANAGEMENT_METER_MONTH_MODEL_LIST:
      return { ...state, modelDeviceList: action.payload };
    case INPUT_MANAGEMENT_METER_MONTH_SEARCH:
      return {
        ...state,
        modelSearch: action.payload,
      };
    case INPUT_MANAGEMENT_METER_MONTH_PAGINATION:
      return { ...state, pagination: { sizePerPage: action.payload.sizePerPage, page: action.payload.page } };
    case INPUT_MANAGEMENT_METER_MONTH_DROP_DOWN_SEARCH_TYPE:
      return {
        ...state,
        dropDownSearchType: action.payload,
      }
    case INPUT_MANAGEMENT_METER_MONTH_DROP_DOWN_SEARCH_SOURCE:
      return {
        ...state,
        dropDownSearchDataSource: action.payload,
      }
    default:
      return state;
  }
};
